// src/modules/app-views/_apps/appsindico/units/pages/Document/tabs/PhotosTab.jsx
// *******************************************************************************
// PHOTOS TAB
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState } from 'react';
import { Upload, Card, Empty, Flex } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { useDocumentContext } from 'components/core/DocumentProvider';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const PhotosTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, isWorking } = useDocumentContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const [fileList, setFileList] = useState([]);

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const photos = data?.photos || [];

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Flex vertical gap={16}>
      {photos.length === 0 && fileList.length === 0 && (
        <Empty description={translateX('no_photos')} className="mb-3" />
      )}

      <Card size="small" title={translateX('upload_photos')}>
        <Upload.Dragger
          multiple
          listType="picture"
          fileList={fileList}
          onChange={handleChange}
          beforeUpload={() => false}
          disabled={isWorking}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">{translateX('drag_files_here')}</p>
        </Upload.Dragger>
      </Card>
    </Flex>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default PhotosTab;
